import axios from '@/api/axiosInstance';

export default async function saveGamificationProgress(activityId, data) {
  const response = await axios.put(
    `${process.env.NEXT_PUBLIC_API_V2}/gamificationProgress/${activityId}`,
    data
  );
  return response.data;
}
